var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"homeSkeleton"},[_c('section',{staticClass:"homeSkeleton-main"},[_c('skeleton-video',{attrs:{"show-controllers":""}})],1),_c('section',{staticClass:"homeSkeleton-sidebar"},[_c('skeleton-video',{attrs:{"show-controllers":""}}),_c('skeleton-video',{attrs:{"show-controllers":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }